/* global axios */

export const getAccountBranding = accountId =>
  axios.get(`/api/v1/accounts/${accountId}/account_branding`);

export const updateAccountBranding = (accountId, payload) =>
  axios.patch(`/api/v1/accounts/${accountId}/account_branding`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
